// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2UPym","footer":"styles_footer__3pq1k"};